import { Injectable } from "@angular/core";
import { JwtHelperService } from '@auth0/angular-jwt';
import { Claim, IdentityUser, Policies } from './identity.models';
import { AuthService } from "./auth.service";

@Injectable()
export class IdentityService
{
	private user: IdentityUser;

	constructor(private jwtHelper: JwtHelperService)
	{
	}

	// get logged identity user
	getUser(): IdentityUser
	{
		// setting user from token
		// decoding token payload
		const tokenPayload = this.jwtHelper.decodeToken(AuthService.getAccessToken());

		// loading user info
		this.user = new IdentityUser();
		this.user.id = tokenPayload[Claim.NameIdentifier];
		this.user.username = tokenPayload[Claim.Name];
		this.user.firstName = tokenPayload[Claim.GivenName];
		this.user.lastName = tokenPayload[Claim.Surname];
		this.user.email = tokenPayload[Claim.EmailAddress];
		this.user.sysAdmin = tokenPayload[Claim.SysAdmin] === 'false' ? false : true;
		this.user.language = tokenPayload[Claim.Language];
		this.user.policies = JSON.parse(tokenPayload[Claim.Policies]);
		this.user.customer = tokenPayload[Claim.Customer] ? JSON.parse(tokenPayload[Claim.Customer]) : null;

		return this.user;
	}

	// verify current user has policy
	hasPolicy(alias: Policies): boolean
	{
		// get current user
		const user: IdentityUser = this.getUser();

		if (!user.sysAdmin)
			return user.policies.indexOf(Policies[alias].toString()) >= 0;
		else
			return true;
	}
}